import { ConfigProvider, ThemeConfig } from 'antd';
import { PropsWithChildren, useMemo } from 'react';

import { useThemeDetector } from '@hook/style/theme-detector.hook';

import { Typography } from './common/typography';
import { DropdownStyle } from './global-style.app';
import { StyleConfigInterface } from './style.interfaces';
import { loadTheme } from './style.util';
import { StyledProvider } from './styled.provider';

const INITIAL_CONFIG: ThemeConfig = {
  hashed: false,
  token: Typography,
};

export const StyleApp = ({ children }: PropsWithChildren) => {
  const theme = useThemeDetector();
  const config = useMemo<StyleConfigInterface>(
    () => ({ ...INITIAL_CONFIG, ...loadTheme(theme) }) as StyleConfigInterface,
    [theme],
  );

  return (
    <ConfigProvider theme={config}>
      <StyledProvider components={config.components}>
        <DropdownStyle />
        {children}
      </StyledProvider>
    </ConfigProvider>
  );
};
